import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InlineTableService } from '@morningstar/shared/base/base-service/inline-table-service';
import { MeetingAttendee } from '@morningstar/shared/meeting-attendees';
import { MeetingAttendeeSelectors } from './meeting-attendee.selectors';
import { Observable } from 'rxjs';

@Injectable()
export class MeetingAttendeeTableService extends InlineTableService<MeetingAttendee> {

  dataDescription = 'attendee';
  baseEndpoint = 'scheduler/meeting/attendees'

  constructor(protected httpClient: HttpClient,
              @Inject('API_BASE_URL') protected baseUrl,
              protected snackbar: MatSnackBar) {
    super(snackbar, httpClient, baseUrl);
  }

  getAttendees(meetingId: number) {
    const endpoint = `scheduler/meeting/${meetingId}/attendees`;
    this.getInlineData(endpoint);
  }

  getAttendeePeopleOptions(meetingId: number) {
    const endpoint = `scheduler/meeting/${meetingId}/attendee-people-options`;
    this.read(MeetingAttendeeSelectors.peopleOptions, endpoint)
        .subscribe();
  }

  getAttendeesObservable(meetingId: number): Observable<MeetingAttendee[]> {
    const endpoint = `scheduler/meeting/${meetingId}/attendees`;
    return this.read('attendees', endpoint);
  }
}
